import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { useParams } from "react-router-dom";

function Redirect() {
  const { slug } = useParams();
  const [urls, setUrls] = useState([]);


  // Youtube token
  const youtubeToken = 'QUFFLUhqbXJvTUhfNG9CZG8yTVBHSUMyLS1rX1h0ankxUXxBQ3Jtc0tuNzd6dkxfY1RSMW8xSVdSMUxBcFUzV192ckYtRE8weGlZUVBaVGxFb2ZsTzZNVkVWWXV6RTBxU3czci1PZnNabS14RmxkbEZLcHdWQ2tNa00zVGRKRTNnOEphYmVqMmo3WFNBMVd3TGRpVG91RGNPOA'



useEffect(() => {
  let query = db.collection("urls").where("slug", "==", slug);
  query.onSnapshot((data) => {
    if (data.empty) {
      alert("URL not found");
    }
    let finalData = data.docs[0].data();
    setUrls(
      [
        finalData.url,
        finalData.url,
        finalData.url,
        finalData.url,
        finalData.url,
        finalData.url,
        finalData.url,
        finalData.url,
        finalData.url,
      ].map((url) => encodeURIComponent(url))
    );
  });
}, [slug]);


if (urls.length > 0) {
  let randomIndex = Math.floor(Math.random() * urls.length);
  let redirectUrl = `vnd.youtube://youtube.com/redirect?event=comments&redir_token=${youtubeToken}&q=${urls[randomIndex]}&html_redirect=1`;;
  window.location.href = redirectUrl;
}

return (
  <>

  </>
);
}

export default Redirect;
